module.exports = __webpack_public_path__ + "img/dongzuomofang.3d5e5fa2.png";